import { render } from "./login_bg.svg?vue&type=template&id=15411cff"
const script = {}
script.render = render

export default script